/**
 * ROP membership + capability helpers from license / instance payload.
 * Prefer ``rop_program.capabilities`` / ``rop_programs``.
 *
 * TODO(rop-migration): remove ``is_fau_related`` dual-read and deprecated
 * ``isFAURelated`` / ``selectIsFAURelated`` aliases after prod + TTL cycle.
 */

export function hasCapability(instanceData, slug) {
  if (!instanceData || !slug) return false;
  const caps = instanceData?.rop_program?.capabilities;
  if (caps && typeof caps === 'object' && slug in caps) {
    return Boolean(caps[slug]);
  }
  // TODO(rop-migration): remove is_fau_related dual-read after this ships to
  // prod and one license-cache TTL cycle has elapsed (SRM no longer emits it).
  if (instanceData?.is_fau_related != null) {
    return Boolean(instanceData.is_fau_related);
  }
  return isRopRelated(instanceData);
}

export function isRopRelated(instanceData) {
  if (!instanceData) return false;
  if (
    Array.isArray(instanceData.rop_programs) &&
    instanceData.rop_programs.length > 0
  ) {
    return true;
  }
  if (
    instanceData.rop_program &&
    typeof instanceData.rop_program === 'object'
  ) {
    return true;
  }
  // TODO(rop-migration): remove is_fau_related dual-read after prod + TTL cycle.
  return Boolean(instanceData.is_fau_related);
}

/** @deprecated Use isRopRelated. TODO(rop-migration): remove after callers migrate. */
export const isFAURelated = isRopRelated;

export function selectIsRopRelated(state) {
  const data = (state.instance && state.instance.data) || {};
  return isRopRelated(data);
}

/** @deprecated Use selectIsRopRelated. TODO(rop-migration): remove after callers migrate. */
export const selectIsFAURelated = selectIsRopRelated;

export function selectHasCapability(slug) {
  return state => {
    const data = (state.instance && state.instance.data) || {};
    return hasCapability(data, slug);
  };
}
